<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M9.39947 6.39947C9.73142 6.06753 10.2687 6.06753 10.6006 6.39947L15.6006 11.3995C15.9325 11.7314 15.9326 12.2687 15.6006 12.6006L10.6006 17.6006C10.2687 17.9326 9.73142 17.9325 9.39947 17.6006C9.06753 17.2687 9.06753 16.7314 9.39947 16.3995L13.7989 12.0001L9.39947 7.60064C9.06753 7.2687 9.06753 6.73142 9.39947 6.39947Z"
      fill="white" />
  </svg>
</template>
